import React from "react";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1560179707-f14e90ef3623?auto=format&fit=crop&w=1600&q=80";

const awards = [
  { year: "2022", text: "VMware / JLL — Best Safety Practices" },
  { year: "2020", text: "ANSR Global / DWP Interics — EHS Excellence" },
  { year: "2019", text: "Google / Colliers — Best Safety Practices" },
  { year: "2019", text: "Oracle / Synergy — 1M Safe Man-Hours" },
  { year: "2018", text: "Amazon / CBRE — Best Safety Team" },
  { year: "2016", text: "NetApp — EHS Award for Best Safety Practices" },
  { year: "—", text: "Intel SRR4 / JLL, ABB, Oracle / JLL — Motivational" },
];

export default function About() {
  return (
    <section
      data-testid="about-section"
      id="about"
      className="bg-white border-t border-line"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 lg:py-28">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          {/* Left — Bio */}
          <div className="lg:col-span-7" data-testid="founder-bio">
            <p className="mono-label">Founder &amp; Lead Auditor</p>
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl uppercase tracking-tighter mt-5 leading-[0.9]">
              Sabari Giri
              <br />
              Eshwaran<span className="text-accent-red">.</span>
            </h2>

            <div className="mt-10 space-y-5 text-ink/80 text-base leading-relaxed max-w-2xl">
              <p>
                A CPD-certified EHS Consultant and HOD — EHS with{" "}
                <span className="font-semibold text-ink">
                  17+ years of progressive practice
                </span>{" "}
                across industrial, construction and IT-campus operations.
                Trained as an electrical engineer (NMIT, VTU) and post-graduated
                in Industrial Safety Engineering, Safety &amp; Risk Analytics
                and Construction Safety at IIT Kharagpur.
              </p>
              <p>
                Career highlight:{" "}
                <span className="font-semibold text-ink">
                  35 million safe man-hours with zero Lost Time Injuries
                </span>{" "}
                across 50+ concurrent project sites — Google, Amazon, Oracle,
                VMware, ANSR Global, Intel, NetApp and ABB — recognised with{" "}
                <span className="font-semibold text-ink">24 industry EHS awards</span>{" "}
                and zero non-compliances across twenty consecutive ISO 45001
                external audits.
              </p>
              <p>
                M/s Sabari Consultant carries that same standard into your
                operation: rigorous diagnosis, blueprint-grade systems, and
                governance you can defend in any audit room. The firm operates
                as a proprietorship under{" "}
                <span className="font-semibold text-ink">
                  Mrs. Sindhu Sabari
                </span>
                , with Sabari Giri Eshwaran leading the technical practice.
              </p>
            </div>

            {/* Capability tags */}
            <div className="mt-10 flex flex-wrap gap-2">
              {[
                "ISO 45001 Lead Auditor",
                "ISO 14001 / 9001",
                "NEBOSH IGC",
                "IOSH Managing Safely",
                "SAP S/4HANA EHS",
                "Power BI EHS Analytics",
                "ESG & Carbon Reporting",
                "HAZOP · HIRA · FMEA",
                "CAPA · RCA · MOC",
              ].map((tag) => (
                <span
                  key={tag}
                  className="font-mono text-[11px] uppercase tracking-wider border border-ink/20 px-3 py-1.5 hover:bg-ink hover:text-white transition-colors"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {/* Right — Image + Awards */}
          <div className="lg:col-span-5 flex flex-col gap-8">
            <div className="relative overflow-hidden border border-line">
              <img
                src={ABOUT_IMG}
                alt="Corporate IT campus skyline representing safety governance"
                className="w-full h-[320px] lg:h-[380px] object-cover grayscale contrast-110"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-black/85 text-white px-5 py-3 flex items-center justify-between">
                <span className="mono-label !text-white/70">Bengaluru · KA</span>
                <span className="font-mono text-xs">12.41°N · 77.59°E</span>
              </div>
            </div>

            <div className="border border-line">
              <div className="px-5 py-3 border-b border-line bg-bgalt flex items-center justify-between">
                <span className="mono-label">Awards Ledger</span>
                <span className="font-mono text-[11px] text-ink-muted">24 awards · selection</span>
              </div>
              <ul>
                {awards.map((a, i) => (
                  <li
                    key={i}
                    className="px-5 py-3 border-b border-line last:border-b-0 flex items-start gap-4 text-sm hover:bg-bgalt transition-colors"
                  >
                    <span className="font-mono text-xs text-accent-red w-10 shrink-0">
                      {a.year}
                    </span>
                    <span className="text-ink/80">{a.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
